export { GolfLandingTemplate } from './GolfLandingTemplate';
export type { GolfLandingTemplateProps, GolfLandingTile } from './GolfLandingTemplate.types';
